module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/bg-wave-bottom-ae97487c1835c5bb41f701fa1b67b7fd.svg";